import { Controller } from "@hotwired/stimulus"
import debounce from "debounce"

export default class extends Controller {
  static targets = ["form"]

  static values = {
    debounceWait: { type: Number, default: 150 }
  }

  connect() {
    // Assigned lazily so a Turbo cache restore doesn't wrap an already
    // debounced function in a second debounce
    this.debouncedSubmit ||= debounce(() => {
      this.formTarget.requestSubmit()
      this.dispatch("submitted")
    }, this.debounceWaitValue)
  }

  disconnect() {
    this.debouncedSubmit.clear()
  }

  addQueryString(event) {
    const params = new URLSearchParams(new FormData(event.target))
    const url = new URL(window.location)
    url.search = params.toString()

    Turbo.navigator.history.replace(url)
  }

  clearInput(event) {
    const input = event.params.clearInput 
      ? this.element.querySelector(`input[name="${event.params.clearInput}"]`)
      : event.target

    if (!input) {
      console.warn(`Input not found.`)
    } else {
      input.value = ""
    }
  }

  submit (event) {
    if (event.target.form) {
      event.target.form.requestSubmit() 
    } else {
      this.formTarget.requestSubmit()
    }

    this.dispatch('submitted')
  }

  submitDebounced() {
    this.debouncedSubmit()
  }
}
